export default {
  items: [],
  pagination: {
    pageSize: 10,
    pageCount: 1,
    page: 1
  }
}
